export default __webpack_public_path__ + "assets/front/scss/affichage-mosaic.f237df9e14fe39cbf1fc5a81874a96b8.css";